import React from "react";
import AppRouter from "./view/navigation/AppRouter";

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
